import { css } from '@emotion/react'
import { BlogsQuery } from '@graphql-types'
import { GatsbyImage } from 'gatsby-plugin-image'
import { Link } from 'gatsby-plugin-react-i18next'
import React from 'react'
import { maxWidth } from 'src/themes'

type Blog = BlogsQuery['blogs']['nodes'][number]

export function BlogComponent({
	blog,
}: {
	blog: Pick<
		Blog,
		'path' | 'title' | 'author' | 'coverImageSharp' | 'date' | 'caption'
	>
}) {
	return (
		<>
			<Link
				to={('/' + blog.path).replace(/^\/\//, '/')}
				css={css`
					display: flex;
					margin-bottom: 2rem;
					width: 100%;

					${maxWidth[1]} {
						flex-direction: column;
					}

					&:hover {
						text-decoration: none;
					}

					h2 {
						margin-top: 0;
						margin-bottom: 0.5rem;
						font-weight: 500;
						font-size: 1.5rem;
					}

					&.past {
						filter: grayscale(90%);
						opacity: 0.5;
					}
				`}>
				<div
					css={css`
						width: 300px;
						margin-right: 2rem;
					`}>
					<GatsbyImage
						image={
							blog.coverImageSharp?.childImageSharp
								?.gatsbyImageData
						}
						alt={blog.title}
					/>
				</div>
				<div
					css={css`
						flex: 1;
					`}>
					<h2>{blog.title}</h2>
					<div
						css={css`
							display: flex;
							align-items: center;

							> div {
								margin-right: 1rem;
							}
						`}>
						<GatsbyImage
							css={css`
								border-radius: 50%;
							`}
							image={
								blog.author.profileImgSharp?.childImageSharp
									?.gatsbyImageData
							}
							alt={blog.title}
						/>
						{blog.author.name}
						<br />
						{blog.date}
					</div>
					<p>{blog.caption}</p>
				</div>
			</Link>
			<hr />
		</>
	)
}
